module.exports = __webpack_public_path__ + "img/paysec_WECHAT.f3108f47.svg";